import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import TimeSlot from './TimeSlot';

import cx from 'classnames';
import s from './Day.css';


const Day = ({ date, handleTimeSlotSelection }) => {
  const dayName = moment(date.date).format('ddd DD MMM');

  return (
    <div className={s.component}>
      <h5 className={cx(s.cell, s.header)}>
        {dayName}
      </h5>
      <TimeSlot
        date={date.date}
        slots={date.slots}
        handleTimeSlotSelection={handleTimeSlotSelection}
      />
    </div>
  );
};

Day.propTypes = {
  dates: PropTypes.array,
  handleTimeSlotSelection: PropTypes.func,
};

export default Day;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Calendar/Day.js